import React from "react";
import {
  Datagrid,
  List,
  TextField,
  Create,
  SimpleForm,
  TextInput,
  ChipField,
  SingleFieldList,
  ReferenceField,
  ImageField,
  ImageInput,
  NumberInput,
  ReferenceManyField,
} from "react-admin";
import Edit from "./components/Edit";
import RichTextInput from "ra-input-rich-text";

export const CategoryList = (props) => {
  return (
    <List {...props}>
      <Datagrid rowClick="edit">
        <TextField source="name" />
        <TextField source="order" />

        <ReferenceManyField reference="Mindfulness" target="category_some">
          <SingleFieldList>
            <ChipField source="name" />
          </SingleFieldList>
        </ReferenceManyField>

      </Datagrid>
    </List>
  );
};
const CategoryFormInput = ({ ...props }) => {

  return (
    <SimpleForm {...props} warnWhenUnsavedChanges>
      
      <TextInput source="name" />
      <RichTextInput source="description" />
      <NumberInput source="order" />
      
      <ReferenceField
      label="Current Image"
      source="image.id"
      reference="File"
      allowEmpty
    >
      <ImageField source="url" title="title" />
    </ReferenceField>

    <ImageInput source="imageId" label="New Image" accept="image/*">
      <ImageField source="src" title="title" />
    </ImageInput>

      
    </SimpleForm>
  );
};
export const CategoryEdit = (props) => (
  <Edit {...props}>
    <CategoryFormInput />
  </Edit>
);

export const CategoryCreate = (props) => {
  // Read the dayId from the location which is injected by React Router and passed to our component by react-admin automatically
  return (
    <Create {...props}>
      <CategoryFormInput />
    </Create>
  );
};
